// ...existing code...
import { FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetAuftraegeMutation } from '../../api/AuftragAPI';
import { IAuftrag } from '../../types/Types';
import { formatToEuroDate } from '../../util/DateUtils';
import ButtonStartNaviComponent from '../ButtonStartNaviComponent/ButtonStartNaviComponent';
import styles from './calendarcomponent.module.scss';


interface CalendarComponentProps {
  //callback1?: (location: ILocation) => void; // Callback-Prop
  //  statusChanged: () => void;
  // numberOnMap: number,
}

/**
 * @author noone
 */
const CalendarComponent: React.FC<CalendarComponentProps> = ({ }) => {

  const [getAuftraegAPI] = useGetAuftraegeMutation();
  const [auftraege, setAuftraege] = useState<IAuftrag[]>([]);
  const [getAnzeigemontag, setAnzeigemontag] = useState<Date>(new Date());
  const [getTagZumAnzeigen, setTagZumAnzeigen] = useState<Date>(new Date());
  const [tage, setTage] = useState<Map<number, Date>>(new Map());
  const navigate = useNavigate();

  const ermitteleMontagInDieserWoche = () => {
    const montag = new Date();
    const day = montag.getDay();
    const diff = (day + 6) % 7;
    montag.setDate(montag.getDate() - diff);
    setAnzeigemontag(montag);
  }

  const lade = () => {
    getAuftraegAPI().unwrap()
      .then(data => setAuftraege(data));
  }

  const eineWocheZurück = () => {
    setAnzeigemontag(new Date(getAnzeigemontag.setDate(getAnzeigemontag.getDate() - 7)));
  }

  const eineWocheSpäter = () => {
    setAnzeigemontag(new Date(getAnzeigemontag.setDate(getAnzeigemontag.getDate() + 7)));
  }

  function isSameDay(date1: Date | null, date2: Date): boolean {
    return formatToEuroDate(date1) === formatToEuroDate(date2);
  }

  // Stunden 0..23
  const hours = Array.from({ length: 24 }, (_, i) => i);

  const getAppointmentsForDayAndHour = (day: Date, hour: number) => {
    return auftraege.filter(a => {
      if (!a.aktuellerTermin) return false;
      const d = new Date(a.aktuellerTermin);
      return isSameDay(d, day) && d.getHours() === hour;
    });
  }

  useEffect(() => {
    const newTage = new Map<number, Date>();
    for (let i = 0; i < 5; i++) {
      const tag = new Date(getAnzeigemontag);
      tag.setDate(getAnzeigemontag.getDate() + i); // <-- hier werden die Folgetage erzeugt
      newTage.set(i, tag);
    }
    setTage(newTage);
  }, [getAnzeigemontag]);

  useEffect(() => {
    lade();
    ermitteleMontagInDieserWoche();
  }, []);

  return (
    <>

      <p>
        Anzahl {auftraege.length}
      </p>

      <button className="btn btn-light" onClick={eineWocheZurück}>Früher</button>
      <button className="btn btn-light" onClick={eineWocheSpäter}>Später</button>

      <div className={styles.aussendiensttage}>
        {Array.from(tage.entries()).map(([index, date]) => (
          <div key={index} className={styles.dayColumn + " card"}>
            <div className={styles.dayHeader}>
              <button className="btn btn-secondary m-1" onClick={() => setTagZumAnzeigen(date)}>
                {(index === 0) ? "Montag" : index === 1 ? "Dienstag" : index === 2 ? "Mittwoch" : index === 3 ? "Donnerstag" : index === 4 ? "Freitag" : "Unbekannt"}<br />
                {formatToEuroDate(date)}
              </button>
            </div>

            <div className={styles.hoursContainer}>
              {hours.map(h => {
                const apps = getAppointmentsForDayAndHour(date, h);
                return (
                  <div key={h} className={styles.hourRow}>
                    <div className={styles.hourLabel}>{h}:00</div>
                    <div className={styles.hourContent}>
                      {apps.length === 0 && <div className={styles.hourEmpty}></div>}
                      {apps.map((auftrag, idx) => (
                        <div key={idx} className={styles.appointment}>
                          <div className={styles.appointmentTitle}>
                            {auftrag.stadt_lieferadresse} {auftrag.name_endkunde}
                          </div>
                          <div className={styles.appointmentActions}>
                            <ButtonStartNaviComponent auftrag={auftrag} />

                            <button
                              className="btn btn-primary btn-sm"
                              onClick={(event: FormEvent) => {
                                event.stopPropagation();
                                window.open(
                                  "./.auftragdetails?uid=" + auftrag?.uid + "&backbuttonClose=true",
                                  "_blank"
                                );
                                /*navigate({
                                  pathname: "./.auftragdetails",
                                  search: "?uid=" + auftrag?.uid // + "&backbuttonClose=true",
                                });*/
                              }} ><i className='bi bi-pencil-fill'></i></button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

          </div>

        ))}
      </div>

      Tag zum Anzeigen: {formatToEuroDate(getTagZumAnzeigen)}

    </>
  );

}

export default CalendarComponent;